export default __webpack_public_path__ + "static/media/zodiacToto-Rabbit.d73ca3de.png";